// @tg-seq: 10002
// @tg-master: SHAFT
/**
 * Default SHAFT Elevator — Master Template (pattern_id = 1)
 *
 * ARCHITECTURE: Single master component for ALL SHAFT-patterned directories.
 * Extracts the target directory Sequence_Num from the current URL path
 * and delegates to DirmShaftPattern which reads the pre-built manifest.
 *
 * URL convention: /{prefix}_tgc_{seq}_{description}_{suffix}
 *   → extracts {seq} → passes to DirmShaftPattern
 *
 * Fallback seq: 10002 (self)
 *
 * pattern_id: 1 (SHAFT)  elevator buttons from directory-navigation-manifest.json
 *
 * Created: 2026-04-03
 */

import React from 'react';
import { useLocation } from 'react-router-dom';

import { getTsxFileName } from '../../utils/componentIdentity';
import { DirmShaftPattern } from '../ComponentTemplates/DirectoryPatterns';

/** Extract Sequence_Num from URL: /_tgc_{NNNNN}_/ */
function useRouteSeq(fallback: number): number {
    const { pathname } = useLocation();
    const match = pathname.match(/_tgc_(\d+)_/);
    return match ? parseInt(match[1], 10) : fallback;
}

const Self: React.FC = () => {
    const seq = useRouteSeq(10002);
    return <DirmShaftPattern seq={seq} />;
};

Self.displayName = getTsxFileName(import.meta.url);

export default Self;
